import { useSelector } from 'react-redux';
import type { OverviewState } from '../../types.ts';
import { TableName } from './constants.ts';

export const getBilddiaSubTableSelector = (state: OverviewState) => state.data.present.getSubTable(TableName);

export const useGetBilddiaSubTable = () => {
    return useSelector(getBilddiaSubTableSelector);
};
